import './flaticon.css';

function Flaticon(props) {
    return (
        <i className={`flaticon-${props.icon}`}>
        </i>
    );
}

export default Flaticon;
